<template>
  <div class="mine-page">
    <div class="mine-shell">
      <header class="mine-head">
        <h1>{{ copy.title }}</h1>
      </header>

      <section class="vip-shell">
        <div class="vip-card">
          <img class="vip-cover" src="/mine-vip-cover.jpg" :alt="copy.vipTitle" />
          <div class="vip-shade"></div>
          <div class="vip-body">
            <div class="vip-brand">
              <span>PornHub8</span>
              <b>VIP</b>
            </div>

            <div class="vip-benefit">
              <p>{{ copy.vipSlogan }}</p>
              <em>{{ copy.vipLevel }}</em>
            </div>

            <div class="vip-meta">
              <div>{{ copy.vipHolder }}: {{ cardHolderNo }}</div>
              <div class="vip-no">
                <span>{{ cardNo }}</span>
                <button v-if="cardDigits" type="button" class="copy-btn" @click="copyCardNo">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9">
                    <rect x="9" y="9" width="11" height="11" rx="2"></rect>
                    <path d="M6 15H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1"></path>
                  </svg>
                </button>
              </div>
            </div>

            <div class="vip-status">
              <button
                type="button"
                class="vip-status-btn"
                :class="{ verified: isCertified }"
                @click="goVerify"
              >
                {{ certStatusText }}
              </button>
              <small>{{ copy.vipCert }} {{ certProgressText }}</small>
            </div>
          </div>
        </div>
      </section>

      <section class="account-card">
        <div class="account-user">
          <div class="avatar-badge">
            <span>{{ avatarText }}</span>
          </div>

          <div class="account-copy">
            <h2>{{ displayName }}</h2>
            <p>
              <i class="online-dot"></i>
              <span>{{ identityText }}</span>
            </p>
          </div>

          <em class="credit-badge">{{ copy.creditLabel }}{{ creditScore }}</em>
        </div>

        <div class="balance-box">
          <div class="balance-head">
            <span>{{ copy.balanceLabel }}</span>
            <button type="button" class="balance-toggle" @click="balanceVisible = !balanceVisible">
              {{ balanceVisible ? copy.balanceHide : copy.balanceShow }}
            </button>
          </div>

          <div class="balance-value">
            <b>{{ balanceText }}</b>
            <small>{{ copy.balanceUnit }}</small>
          </div>

          <div class="balance-actions">
            <button type="button" class="ghost-btn" @click="goRecharge">{{ copy.recharge }}</button>
            <button type="button" class="primary-btn" @click="doWithdrawal">{{ copy.withdraw }}</button>
          </div>
        </div>
      </section>

      <section class="mine-section">
        <h3>{{ copy.quickTitle }}</h3>
        <div class="quick-grid">
          <button
            v-for="item in quickActions"
            :key="item.key"
            class="quick-item"
            type="button"
            @click="openAction(item)"
          >
            <span class="quick-icon" v-html="item.icon"></span>
            <span>{{ item.label }}</span>
          </button>
        </div>
      </section>

      <section class="mine-section">
        <h3>{{ copy.settingTitle }}</h3>
        <div class="setting-list">
          <button
            v-for="item in settingActions"
            :key="item.key"
            class="setting-row"
            :class="{ logout: item.key === 'logout' }"
            type="button"
            @click="openAction(item)"
          >
            <span class="setting-icon" v-html="item.icon"></span>
            <span class="setting-copy">
              <b>{{ item.label }}</b>
              <i v-if="item.key === 'crush' && favoriteCount > 0" class="count-badge">{{ favoriteCount }}</i>
            </span>
            <svg class="setting-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 18l6-6-6-6"></path>
            </svg>
          </button>
        </div>
      </section>
    </div>

    <Footer :is_show="true" />
  </div>
</template>

<script>
import Footer from "@/common/Footer.vue";
import { getPageCopy } from "@/common/pageLocale";

const QUICK_ICONS = {
  cert:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M7 3h8l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"></path><path d="M15 3v5h5"></path><path d="M9 13h6M9 17h4"></path></svg>',
  ledger:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="3" width="16" height="18" rx="2"></rect><path d="M8 8h8M8 12h8M8 16h5"></path></svg>',
  withdraw:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 4v12"></path><path d="M7 11l5 5 5-5"></path><path d="M5 20h14"></path></svg>',
  recharge:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 20V8"></path><path d="M7 13l5-5 5 5"></path><path d="M5 4h14"></path></svg>',
  profile:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="12" cy="8" r="3.4"></circle><path d="M5 19.2c.8-3.4 3.3-5.2 7-5.2s6.2 1.8 7 5.2"></path></svg>',
  crush:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 20.4S4.2 15.2 4.2 9.8A4.4 4.4 0 0 1 12 7.4a4.4 4.4 0 0 1 7.8 2.4c0 5.4-7.8 10.6-7.8 10.6z"></path></svg>',
  bank:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="3.5" y="6" width="17" height="12" rx="2.2"></rect><path d="M3.5 10h17"></path><path d="M7.5 15h4"></path></svg>',
  password:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="6" y="11" width="12" height="9" rx="2"></rect><path d="M8.5 11V8.4a3.5 3.5 0 0 1 7 0V11"></path></svg>',
  logout:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M10 21H6.5A2.5 2.5 0 0 1 4 18.5v-13A2.5 2.5 0 0 1 6.5 3H10"></path><path d="M11 12h9"></path><path d="M16.5 8.5 20 12l-3.5 3.5"></path></svg>',
};

export default {
  components: {
    Footer,
  },
  data() {
    return {
      userInfo: {},
      vipInfo: null,
      bankInfo: null,
      balanceVisible: true,
      favoriteCount: 0,
      certProgressCount: 0,
    };
  },
  computed: {
    copy() {
      return getPageCopy(this, "mine");
    },
    isLoggedIn() {
      return !!localStorage.getItem("token");
    },
    displayName() {
      return this.userInfo.username || this.userInfo.name || "--";
    },
    avatarText() {
      const source = this.userInfo.name || this.userInfo.username || this.userInfo.id || "";
      return source ? String(source).trim().slice(0, 1).toUpperCase() : "";
    },
    cardDigits() {
      const raw = `${this.userInfo.id || ""}${this.userInfo.mobile || ""}${this.userInfo.username || ""}`.replace(/\D/g, "");
      return raw ? raw.slice(-8) : "";
    },
    cardHolderNo() {
      return this.cardDigits ? `VIP${this.cardDigits.slice(-6)}` : "--";
    },
    cardNo() {
      return this.cardDigits ? `NO.${this.cardDigits}` : "--";
    },
    isCertified() {
      return Number(this.vipInfo && this.vipInfo.auth_status) === 1;
    },
    certStatusText() {
      return this.isCertified ? this.copy.certified : this.copy.notCertified;
    },
    certProgressText() {
      return `${this.certProgressCount} / 10`;
    },
    identityText() {
      if (!this.userInfo || (!this.userInfo.id && !this.userInfo.username && !this.userInfo.name)) {
        return "--";
      }
      return `${this.copy.localIdentity} · ${this.isCertified ? this.copy.identityActive : this.copy.identityInactive}`;
    },
    creditScore() {
      const raw = this.vipInfo && this.vipInfo.score != null ? this.vipInfo.score : this.userInfo.score;
      if (raw == null || raw === "") {
        return "--";
      }
      const num = Number(raw);
      return Number.isFinite(num) ? num : "--";
    },
    balanceText() {
      if (!this.balanceVisible) {
        return "****";
      }
      if (this.userInfo.money == null || this.userInfo.money === "") {
        return "--";
      }
      return Number(this.userInfo.money).toFixed(2);
    },
    quickActions() {
      return [
        { key: "certLog", label: this.copy.quickCert, icon: QUICK_ICONS.cert, action: "route", path: "/GameRecord" },
        { key: "ledger", label: this.copy.quickLedger, icon: QUICK_ICONS.ledger, action: "route", path: "/Account" },
        { key: "withdrawLog", label: this.copy.quickWithdraw, icon: QUICK_ICONS.withdraw, action: "route", path: "/WithdrawRecord" },
        { key: "rechargeLog", label: this.copy.quickRecharge, icon: QUICK_ICONS.recharge, action: "route", path: "/RechargeRecord" },
      ];
    },
    settingActions() {
      return [
        { key: "profile", label: this.copy.settingProfile, icon: QUICK_ICONS.profile, action: "route", path: "/Infomation" },
        { key: "crush", label: this.copy.settingCrush, icon: QUICK_ICONS.crush, action: "route", path: "/CrushList" },
        { key: "bank", label: this.copy.settingBank, icon: QUICK_ICONS.bank, action: "bank" },
        { key: "password", label: this.copy.settingPassword, icon: QUICK_ICONS.password, action: "route", path: "/SetLoginPassword" },
        { key: "logout", label: this.copy.settingLogout, icon: QUICK_ICONS.logout, action: "logout" },
      ];
    },
  },
  created() {
    if (this.isLoggedIn) {
      this.fetchMineData();
    }
  },
  methods: {
    async fetchMineData() {
      await Promise.all([
        this.getUserInfo(),
        this.getVipInfo(),
        this.getBankInfo(),
        this.getFavoriteCount(),
        this.getCertProgress(),
      ]);
    },
    async getUserInfo() {
      const res = await this.$http({
        method: "get",
        url: "user_info",
      });
      if (res && res.code === 200) {
        this.userInfo = res.data || {};
      }
    },
    async getVipInfo() {
      const res = await this.$http({
        method: "get",
        url: "user_info",
        data: { type: 1 },
      });
      if (res && res.code === 200) {
        this.vipInfo = res.data || null;
      }
    },
    async getBankInfo() {
      const res = await this.$http({
        method: "get",
        url: "user_get_bank",
      });
      if (res && res.code === 200) {
        this.bankInfo = res.data || null;
      }
    },
    async getFavoriteCount() {
      const res = await this.$http({
        method: "get",
        url: "xuanfei_favorite_ids",
      });
      if (res && res.code === 200 && Array.isArray(res.data)) {
        this.favoriteCount = res.data.length;
        return;
      }
      this.favoriteCount = 0;
    },
    async getCertProgress() {
      const res = await this.$http({
        method: "get",
        url: "user_get_recharge_list",
      });
      if (res && res.code === 200) {
        const list = Array.isArray(res.data) ? res.data : Object.values(res.data || {});
        const approvedCount = list.filter((item) => {
          const status = Number(item && item.status);
          return status === 2 || status === 4;
        }).length;
        this.certProgressCount = Math.min(approvedCount, 10);
        return;
      }
      this.certProgressCount = 0;
    },
    ensureLogin() {
      if (this.isLoggedIn) {
        return true;
      }
      this.$toast(this.copy.loginFirst);
      this.$router.push("/Login");
      return false;
    },
    goVerify() {
      if (!this.ensureLogin()) {
        return;
      }
      this.$router.push("/Game");
    },
    goRecharge() {
      if (!this.ensureLogin()) {
        return;
      }
      this.$router.push("/Recharge");
    },
    async doWithdrawal() {
      if (!this.ensureLogin()) {
        return;
      }
      const res = await this.$http({
        method: "get",
        url: "user_get_bank",
      });
      if (res && res.code === 200 && res.data && res.data.is_bank) {
        this.$router.push("/Withdraw");
        return;
      }
      this.$router.push("/Setbank");
      this.$toast(this.copy.bindBankFirst);
    },
    async openAction(item) {
      if (item.action === "logout") {
        this.logout();
        return;
      }
      if (!this.ensureLogin()) {
        return;
      }
      if (item.action === "bank") {
        if (this.bankInfo && this.bankInfo.is_bank) {
          this.$router.push("/Setbank");
          return;
        }
        this.$router.push("/Setbank");
        return;
      }
      if (item.path) {
        this.$router.push(item.path);
      }
    },
    logout() {
      if (!this.isLoggedIn) {
        this.$router.push("/Login");
        return;
      }
      const lang = localStorage.getItem("lang");
      const displayLang = localStorage.getItem("login_display_lang");
      localStorage.clear();
      if (lang) {
        localStorage.setItem("lang", lang);
      }
      if (displayLang) {
        localStorage.setItem("login_display_lang", displayLang);
      }
      this.$toast(this.copy.logoutSuccess);
      this.$router.replace("/Login");
    },
    async copyCardNo() {
      if (!this.cardDigits) {
        return;
      }
      const text = this.cardNo;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          const input = document.createElement("input");
          input.value = text;
          document.body.appendChild(input);
          input.select();
          document.execCommand("copy");
          document.body.removeChild(input);
        }
        this.$toast(this.copy.copied);
      } catch (error) {
        this.$toast(text);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.mine-page {
  min-height: 100vh;
  min-height: 100dvh;
  background:
    radial-gradient(circle at 50% 0, rgba(165, 92, 255, 0.18), transparent 28%),
    linear-gradient(180deg, #140818 0%, #06040c 100%);
  color: #fff;
}

.mine-shell {
  width: 100%;
  max-width: 23.4375rem;
  margin: 0 auto;
  padding: 0 0.75rem 6.75rem;
}

.mine-head {
  padding-top: max(0.875rem, env(safe-area-inset-top));
}

.mine-head h1 {
  margin: 0;
  font-size: 1.7rem;
  font-weight: 900;
  line-height: 1.2;
}

.vip-shell {
  margin-top: 0.85rem;
}

.vip-card {
  position: relative;
  min-height: 13rem;
  overflow: hidden;
  border: 1px solid rgba(255, 93, 149, 0.2);
  border-radius: 1.6rem;
  background: rgba(21, 11, 28, 0.92);
}

.vip-cover,
.vip-shade {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.vip-cover {
  object-fit: cover;
}

.vip-shade {
  background:
    linear-gradient(90deg, rgba(8, 4, 12, 0.88) 0%, rgba(8, 4, 12, 0.52) 45%, rgba(8, 4, 12, 0.88) 100%),
    linear-gradient(180deg, rgba(8, 4, 12, 0.05) 0%, rgba(8, 4, 12, 0.7) 100%);
}

.vip-body {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  min-height: 13rem;
  padding: 1rem 1rem 0.95rem;
}

.vip-brand {
  display: flex;
  align-items: flex-end;
  gap: 0.45rem;
  color: #fff;
}

.vip-brand span {
  font-size: 1.55rem;
  font-weight: 900;
  line-height: 1;
  letter-spacing: -0.04em;
}

.vip-brand b {
  color: rgba(191, 211, 255, 0.9);
  font-size: 2.1rem;
  line-height: 0.95;
  letter-spacing: -0.03em;
}

.vip-benefit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.7rem;
  margin-top: 1rem;
}

.vip-benefit p {
  margin: 0;
  color: #fff;
  font-size: 0.88rem;
  font-weight: 700;
}

.vip-benefit em {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 3.45rem;
  height: 1.6rem;
  padding: 0 0.7rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #7a2cff, #ff3c87);
  color: #fff;
  font-size: 0.73rem;
  font-style: normal;
  font-weight: 800;
}

.vip-meta {
  margin-top: auto;
  font-size: 0.8rem;
  font-weight: 700;
}

.vip-no {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.38rem;
}

.copy-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 0.55rem;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.92);
}

.copy-btn svg {
  width: 0.82rem;
  height: 0.82rem;
}

.vip-status {
  position: absolute;
  right: 1rem;
  bottom: 0.95rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.38rem;
}

.vip-status-btn {
  min-width: 5.9rem;
  height: 2.5rem;
  padding: 0 1rem;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.96);
  color: #161018;
  font-size: 0.94rem;
  font-weight: 900;
}

.vip-status-btn.verified {
  background: linear-gradient(135deg, #ff6da3, #ff417f);
  color: #fff;
}

.vip-status small {
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.72rem;
  font-weight: 700;
}

.account-card {
  margin-top: 0.9rem;
  padding: 0.95rem;
  border: 1px solid rgba(255, 93, 149, 0.18);
  border-radius: 1.45rem;
  background: linear-gradient(180deg, rgba(49, 22, 61, 0.94), rgba(25, 13, 34, 0.97));
}

.account-user {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}

.avatar-badge {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  background: conic-gradient(from 220deg, #7a2cff, #ff4b8c 55%, #f3a5ff 100%);
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.02);
}

.avatar-badge::after {
  content: "";
  position: absolute;
  inset: 0.24rem;
  border-radius: 50%;
  background: #2f163b;
}

.avatar-badge span {
  position: relative;
  z-index: 1;
  font-size: 1.3rem;
  font-weight: 900;
}

.account-copy {
  min-width: 0;
  flex: 1;
}

.account-copy h2 {
  margin: 0;
  font-size: 1.22rem;
  font-weight: 900;
  line-height: 1.15;
}

.account-copy p {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin: 0.3rem 0 0;
  color: rgba(255, 255, 255, 0.86);
  font-size: 0.8rem;
  font-weight: 700;
}

.online-dot {
  width: 0.42rem;
  height: 0.42rem;
  border-radius: 50%;
  background: #3cf5b2;
  box-shadow: 0 0 0.55rem rgba(60, 245, 178, 0.62);
}

.credit-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 4.25rem;
  height: 1.8rem;
  padding: 0 0.62rem;
  border-radius: 999px;
  background: rgba(252, 193, 88, 0.16);
  color: #ffcc68;
  font-size: 0.72rem;
  font-style: normal;
  font-weight: 800;
}

.balance-box {
  margin-top: 0.9rem;
  padding-top: 0.85rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.balance-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.82rem;
  font-weight: 700;
}

.balance-toggle {
  border: 0;
  padding: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.8rem;
  font-weight: 700;
}

.balance-value {
  display: flex;
  align-items: flex-end;
  gap: 0.35rem;
  margin-top: 0.42rem;
}

.balance-value b {
  font-size: 2.1rem;
  line-height: 1;
  font-weight: 900;
}

.balance-value small {
  color: #ff5e98;
  font-size: 0.95rem;
  font-weight: 800;
}

.balance-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
  margin-top: 0.95rem;
}

.ghost-btn,
.primary-btn {
  min-height: 2.8rem;
  border-radius: 0.95rem;
  font-size: 0.97rem;
  font-weight: 900;
}

.ghost-btn {
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}

.primary-btn {
  border: 0;
  background: linear-gradient(135deg, #ff6da3, #ff417f);
  box-shadow: 0 0.85rem 1.6rem rgba(255, 71, 128, 0.24);
  color: #fff;
}

.mine-section {
  margin-top: 1rem;
}

.mine-section h3 {
  margin: 0 0 0.8rem;
  font-size: 1.2rem;
  font-weight: 900;
}

.quick-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.65rem;
}

.quick-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.58rem;
  min-height: 4.95rem;
  padding: 0.55rem 0.3rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 1rem;
  background: rgba(18, 12, 26, 0.96);
  color: #fff;
}

.quick-item span:last-child {
  font-size: 0.73rem;
  font-weight: 700;
}

.quick-icon,
.setting-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ff74a8;
}

.quick-icon ::v-deep svg,
.setting-icon ::v-deep svg {
  width: 1.16rem;
  height: 1.16rem;
}

.setting-list {
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 1.2rem;
  background: rgba(14, 9, 22, 0.96);
}

.setting-row {
  display: flex;
  align-items: center;
  gap: 0.78rem;
  width: 100%;
  min-height: 3.78rem;
  padding: 0 0.9rem;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background: transparent;
  color: #fff;
  text-align: left;
}

.setting-row:last-child {
  border-bottom: 0;
}

.setting-row.logout .setting-copy b {
  color: #ff86b1;
}

.setting-icon {
  width: 2rem;
  height: 2rem;
  border-radius: 0.65rem;
  background: linear-gradient(180deg, rgba(135, 77, 162, 0.72), rgba(99, 52, 125, 0.55));
}

.setting-copy {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
  flex: 1;
}

.setting-copy b {
  font-size: 0.96rem;
  font-weight: 800;
}

.count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.1rem;
  height: 1.1rem;
  padding: 0 0.28rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #ff5d9c, #ff417f);
  color: #fff;
  font-size: 0.68rem;
  font-style: normal;
  font-weight: 800;
}

.setting-chevron {
  width: 1rem;
  height: 1rem;
  color: rgba(255, 255, 255, 0.42);
}

button {
  cursor: pointer;
}

@media (max-width: 22.5rem) {
  .mine-shell {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .vip-card {
    min-height: 12.3rem;
  }

  .vip-body {
    min-height: 12.3rem;
    padding: 0.9rem 0.9rem 0.88rem;
  }

  .quick-grid {
    gap: 0.5rem;
  }
}

@media (min-width: 48rem) {
  .mine-shell {
    max-width: 25rem;
  }
}
</style>
